import ltAddonZoomDrawer from 'html/addon/lt-addon-zoom-drawer.html';
import App from 'app/app.js';
import 'app/directive/LtAddonZoomDrawerCtrl.js';

function LtAddonZoomDrawerDirective() {
  return {
    restrict: 'E',
    scope: {
      onInit: '&',
      onCancellation: '&',
      zoomAddOn: '=',
      zoomAddOnLarge: '='
    },
    template: ltAddonZoomDrawer,
    controller: 'LtAddonZoomDrawerCtrl',
    controllerAs: 'addonZoomDrawer'
  };
}

App.directive('ltAddonZoomDrawer', [LtAddonZoomDrawerDirective]);
